export class ReportApplicantsSearchModel {
    fecha_procesamiento_inicio: string;
    fecha_procesamiento_fin: string;
    promotor: string;
    producto: string;
}